<template>
  <v-main>
    <Student
      @select="loadStudent"
      ref="student"
      :student="student"
      v-if="mode === 'people' && Object.keys(student).length > 0"
    ></Student>
    <v-card
      flat
      v-if="mode === 'activities' && Object.keys(activity).length > 0"
      class="ma-0 pa-0"
    >
      <v-toolbar height="40">
        <v-card-title class="font-weight-light"
          >{{ activity.name }}
        </v-card-title>
        <template v-slot:extension>
          <v-toolbar flat height="30">
            <v-spacer> </v-spacer>
            <v-dialog v-model="newGroupDialog" width="400">
              <v-card>
                <v-toolbar flat color="primary" dark>
                  <v-card-title class="font-weight-light">{{
                    !newGroup.id ? "Añadir grupo" : "Editar grupo"
                  }}</v-card-title>
                </v-toolbar>
                <v-card-text>
                  <v-text-field
                    label="Nombre"
                    v-model="newGroup.name"
                  ></v-text-field>
                  <v-text-field
                    label="Horario"
                    v-model="newGroup.schedule"
                    hint="Ejemplo LX 16:00-17:30"
                    :rules="[
                      (v) =>
                        /^((L|M|X|J|V)+ (0[0-9]|1[0-9]|2[0-3]):([0-5][0-9])\-(0[0-9]|1[0-9]|2[0-3]):([0-5][0-9])[/]*)+$/.test(
                          v
                        ) || 'Formato incorrecto (Ejemplo LX 16:00-17:30)',
                    ]"
                  ></v-text-field>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-btn
                    text
                    @click="
                      newGroupDialog = false;
                      newGroup = {};
                    "
                    >Cancelar</v-btn
                  >
                  <v-spacer></v-spacer>
                  <v-btn text @click="addNewGroup">{{
                    newGroup.id ? "Confirmar cambios" : "Añadir grupo"
                  }}</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-btn text outlined rounded @click="editGroupDialog(null)">
              <v-icon left>mdi-plus</v-icon>
              Añadir grupo
            </v-btn>
            <v-btn
              :disabled="activity.closed"
              text
              outlined
              rounded
              class="ml-3"
              @click="closeListsDialog = true"
            >
              <v-icon left>mdi-playlist-check</v-icon>
              Cerrar listas
            </v-btn>
            <v-dialog v-model="imagesDialog" width="600">
              <template v-slot:activator="{ on }">
                <v-btn icon class="ml-3" v-on="on">
                  <v-icon>mdi-camera</v-icon>
                </v-btn>
              </template>
              <v-card>
                <v-toolbar color="primary" dark>
                  <v-card-title class="font-weight-ligth"
                    >Imágenes</v-card-title
                  >
                </v-toolbar>
                <v-card-text class="pa-4">
                  <div class="uploader-box">
                    <v-icon x-large class="ml-4 mt-3">mdi-image-plus</v-icon>
                    <input
                      type="file"
                      multiple
                      class="uploader-files"
                      @change="putImages($event, activity.id)"
                    />
                  </div>
                  <div
                    :key="index"
                    v-for="(image, index) in activity.images"
                    class="thumbnail"
                  >
                    <div class="image">
                      <v-img width="78" height="70" :src="image.thumbnailUrl">
                      </v-img>
                    </div>
                    <v-btn
                      dark
                      icon
                      x-small
                      class="remove-image"
                      @click="removeImage(image)"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </div>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text @click="imagesDialog = false">Terminar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-card width="160" flat class="pa-0 ma-0 ml-3">
              <v-switch
                hide-details
                v-model="activity.published"
                @change="togglePublished"
                :label="activity.published ? 'Publicada' : 'No publicada'"
              ></v-switch>
            </v-card>
          </v-toolbar>
        </template>
      </v-toolbar>

      <v-card-text class="ma-0 pa-0">
        <v-container fluid>
          <v-row v-if="activity.groups" class="pa-0 ma-0" no-gutters>
            <v-col
              class="ma-0 pa-2"
              :key="index + '_group'"
              v-for="(group, index) in activity.groups"
              cols="12"
              lg="6"
              xl="4"
            >
              <v-card class="ma-0">
                <v-toolbar dense>
                  <div v-if="group.schedule.trim() !== ''">
                    <div
                      class="when"
                      :key="index"
                      v-for="(when, index) in group.schedule.split('/')"
                    >
                      <v-avatar
                        size="27"
                        class="white--text mr-2 font-weight-bold"
                        color="primary"
                        >{{ when.split(" ")[0] }}</v-avatar
                      >
                      {{ when.split(" ")[1].replace("-", " - ") }}
                      <v-icon
                        v-if="index < group.schedule.split('/').length - 1"
                        >mdi-slash-forward</v-icon
                      >
                    </div>
                  </div>
                  <div v-else>
                    <v-avatar
                      size="27"
                      class="white--text mr-2 font-weight-bold"
                      color="primary"
                      ><v-icon small class="white--text"
                        >mdi-help</v-icon
                      ></v-avatar
                    >
                    Horario por determinar
                  </div>
                  <v-spacer></v-spacer>

                  <v-btn icon @click="printList(group)" color="accent">
                    <v-icon>mdi-printer</v-icon>
                  </v-btn>

                  <v-btn icon @click="editGroupDialog(group)" color="accent">
                    <v-icon>mdi-cog</v-icon>
                  </v-btn>

                  <v-btn
                    :disabled="group.students.length > 0"
                    small
                    color="accent"
                    icon
                    @click="
                      groupToDelete = group;
                      deleteGroupDialog = true;
                    "
                    ><v-icon>mdi-delete</v-icon></v-btn
                  >

                  <v-btn icon @click="reSort(group)" color="accent">
                    <v-icon>mdi-sort</v-icon>
                  </v-btn>
                  <v-dialog> </v-dialog>
                </v-toolbar>
                <v-card-text class="pa-0">
                  <v-subheader>
                    <span v-if="group.name">{{
                      (group.name && group.name.toUpperCase()) || ""
                    }}</span>
                    <v-spacer></v-spacer>
                    <span>{{
                      group.students ?
                        (group.students.length !== 1
                          ? group.students.length + " alumnos inscritos"
                          : "1 alumno inscrito")
                        : 'Aún no hay alumnos inscritos'
                    }}</span>
                  </v-subheader>
                  <v-list three-line v-if="group.students.length">
                    <draggable
                      v-model="group.students"
                      @change="changeStudents(group, activity.id)"
                    >
                      <template v-for="(student, index) in group.students">
                        <v-list-item
                          :key="index + '_student'"
                          class="py-0"
                          :class="{
                            selected:
                              index === activity.max - 1 &&
                              group.students.length > activity.max,
                          }"
                        >
                          <v-list-item-content>
                            <v-list-item-title>
                              {{ student.name }}
                            </v-list-item-title>
                            <v-list-item-subtitle>
                              {{
                                new Date(student.date.seconds * 1000)
                                  | moment("D [de] MMMM [a las] HH:mm[h]")
                              }}
                            </v-list-item-subtitle>
                            <v-list-item-subtitle v-if="student.group">
                              {{ showGroup(student.group) }}
                            </v-list-item-subtitle>
                          </v-list-item-content>
                          <v-list-item-action>
                            <v-card flat color="transparent">
                              <v-tooltip
                                v-if="
                                  student.comments
                                "
                                left
                                elevation="3"
                                max-width="300"
                                color="blue darken-4"
                                dark
                              >
                                <template v-slot:activator="{ on }">
                                  <v-btn icon small color="accent" v-on="on">
                                    <v-icon>mdi-chat</v-icon>
                                  </v-btn>
                                </template>
                                <span>{{ student.comments }}</span>
                              </v-tooltip>
                              <v-btn
                                :color="showPriorityColor(student.priority)"
                                icon
                                small
                                @click="
                                  updatePriority(activity, group, student)
                                "
                                ><v-icon>{{
                                  showPriority(student.priority)
                                }}</v-icon></v-btn
                              >
                              <!--<v-btn icon small>
                                <v-icon>mdi-close</v-icon>
                              </v-btn>-->
                            </v-card>
                          </v-list-item-action>
                        </v-list-item>
                      </template>
                    </draggable>
                  </v-list>
                  <v-list-item v-else>
                    Ningún alumno inscrito en el grupo
                  </v-list-item>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
    <v-card v-if="Object.keys(student).length === 0 && mode === 'people'" flat>
      <v-card-text>
        Selecciona un alumno en el panel de la derecha.
      </v-card-text>
    </v-card>
    <v-card
      v-if="Object.keys(activity).length === 0 && mode === 'activities'"
      flat
    >
      <v-card-text>
        Selecciona una actividad en el panel de la derecha para gestionarla.
      </v-card-text>
    </v-card>
    <v-navigation-drawer app width="400" right clipped permanent>
      <Activities
        v-if="mode === 'activities'"
        @select="loadActivity"
        @students="mode = 'people'"
        @deleted="activity = {}"
      ></Activities>
      <Students
        v-if="mode === 'people'"
        @select="loadStudent"
        @activities="mode = 'activities'"
        ref="students"
      ></Students>
    </v-navigation-drawer>
    <v-dialog v-model="deleteGroupDialog" width="400">
      <v-card>
        <v-toolbar color="primary" dense dark flat>
          <v-card-title class="text-weight-light">Eliminar grupo</v-card-title>
        </v-toolbar>
        <v-card-text class="pa-4">
          ¿Seguro que quieres eliminar el grupo?
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            text
            @click="
              groupToDelete = {};
              deleteGroupDialog = false;
            "
            >Cancelar</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn text @click="deleteGroup" color="red">Eliminar Grupo</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="closeListsDialog" width="500">
      <v-card>
        <v-toolbar>
          <v-card-title> Cerrar grupos </v-card-title>
        </v-toolbar>
        <v-card-text class="pa-3">
          Una vez los grupos estén cerrados las familias recibirán una
          confirmación por correo electrónico indicando si el alumno ha sido
          aceptado o no.
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn text @click="closeListsDialog = false">Cancelar</v-btn>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="closeLists">Cerrar grupos</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-main>
</template>

<script>
/* eslint-disable no-console */
import Students from "../components/Students.vue";
import Student from "../components/Student.vue";
import Activities from "../components/Activities.vue";

import {
  newId,
  fs,
  students,
  activities,
  storage,
  auth,
} from "../firebaseConfig.js";

import draggable from "vuedraggable";

let _ = require("underscore");

export default {
  name: "Home",
  components: { Activities, Students, Student, draggable },
  data() {
    return {
      closeListsDialog: false,
      groupToDelete: {},
      mode: "activities",
      imagesDialog: false,
      endDateDialog: false,
      deleteGroupDialog: false,
      activity: {},
      student: {},
      newGroupDialog: false,
      newGroup: {},
    };
  },
  created() {
    if (!auth.currentUser) this.$router.replace("/login");
    activities
      .orderBy("name")
      .onSnapshot((activitiesRef) => {
        this.$store.state.activities = [];
        activitiesRef.forEach((activityRef) => {
          this.$store.state.activities.push(activityRef.data());
        });
      });
    students.onSnapshot((studentsRef) => {
      this.$store.state.students = [];
      studentsRef.forEach((studentRef) => {
        this.$store.state.students.push(studentRef.data());
      });
    });
  },
  methods: {
    delay(time) {
      return new Promise(resolve => setTimeout(resolve, time));
    },
    printList(group) {
      let listWindow = window.open("", "PRINT", "");
      listWindow.document.write('<div class="page">');
      listWindow.document.write(`<h3>${this.activity.name}</h3><br />`);
      group.students.forEach((student, index) => {
        listWindow.document.write(`<p class="student">${student.name}</p>`);
        if (index === this.activity.max - 1) {
          listWindow.document.write(`<div class="divider"></div>`);
        }
      });
      listWindow.document.write("</div>");
      listWindow.document.write(`<style>
        html {
          font-family: Arial;
        }
        .page {
          padding: 20px 50px;
        }
        .divider {
          height: 2px;
          width: 100%;
          background-color: grey;
        }
      </style>`);
      listWindow.document.close();
      listWindow.focus();
      listWindow.print();
      listWindow.close();
      group.students.forEach((student) => {
        console.log(student.name);
      });
    },
    selectStudent($event) {
      console.log("Select", $event);
      this.student = $event;
    },
    showGroup(group) {
      if (group.length === 4) {
        let result = "";
        let section = group.substr(0, 2);
        let level = group[2];
        let line = group[3];
        switch (section) {
          case "00":
            result = "Infantil ";
            break;
          case "01":
            result = "Primaria ";
            break;
          case "02":
            result = "Secundaria ";
            break;
          case "03":
            result = "Bachillerato ";
            break;
          case "04":
            result = "BI ";
            break;
          case "05":
            result = "Pruebas ";
            break;
        }
        result += level + "º" + line;
        return result;
      } else {
        return "";
      }
    },
    editGroupDialog(group) {
      if (group) {
        this.newGroup = {
          ...group,
        };
        this.newGroupDialog = true;
      } else {
        this.newGroupDialog = true;
      }
    },
    togglePublished($event) {
      console.log($event);
      this.activity.published = $event;
      activities.doc(this.activity.id).update({
        published: this.activity.published,
      });
    },
    removeImage(image) {
      console.log(this.activity.images, image.url);
      activities
        .doc(this.activity.id)
        .update({
          images: fs.FieldValue.arrayRemove(image),
        })
        .then(() => {
          let index = _.findIndex(this.activity.images, { url: image.url });
          this.activity.images.splice(index, 1);
          console.log(image);
        });
    },
    putImages($event, activityId) {
      console.log("IMAGENES", $event.target.files);
      Object.values($event.target.files).forEach((file) => {
        let id = newId();
        let imageRef = storage.child(id);
        imageRef.put(file).then((fileSnapshot) => {
          fileSnapshot.ref.getDownloadURL().then((url) => {
            console.log(url);
            this.getThumbnailURL(id, activityId, url);
          });
        });
      });
    },
    getThumbnailURL(id, activityId, originalUrl) {
      let thumbnailRef = storage.child(`thumbnails/${id}_200x200`);
      thumbnailRef
        .getDownloadURL()
        .then((url) => {
          console.log(url);
          activities.doc(activityId).update({
            images: fs.FieldValue.arrayUnion({
              url: originalUrl,
              thumbnailUrl: url,
            }),
          });
          this.activity.images.push({
            url: originalUrl,
            thumbnailUrl: url,
          });
        })
        .catch((error) => {
          if (error.code === "storage/object-not-found") {
            this.getThumbnailURL(id, activityId, originalUrl);
          } else {
            console.log(error.code);
          }
        });
    },
    reSort(group) {
      let sorted = group.students;
      sorted.sort((a, b) => {
        if (a.priority > b.priority) {
          return 1;
        }
        if (a.priority < b.priority) {
          return -1;
        }
        if (a.priority === b.priority) {
          if (a.date.seconds < b.date.seconds) {
            return -1;
          } else {
            return 1;
          }
        }
      });
      let students = {};
      for (let i = 0; i < sorted.length; i++) {
        sorted[i].index = i;
        students[sorted[i].id] = sorted[i];
      }
      activities
        .doc(this.activity.id)
        .update({
          [`groups.${group.id}.students`]: students,
        })
        .then(() => {
          let index = _.findIndex(this.activity.groups, { id: group.id });
          this.activity.groups[index].students = sorted;
          console.log("Lista reordenada");
        });
    },
    closeLists() {
      console.log("CERRANDO LISTAS");
      activities
        .doc(this.activity.id)
        .update({
          closed: true,
        })
        .then(() => {
          this.closeListsDialog = false;
        });
      /*this.activity.groups.forEach(async (group) => {
        //console.log(
        //  `Cerrando ${group.name || ""} (${group.schedule || "Por confirmar"})`
        //);
        if (group.students.length < this.activity.min) {
          group.students.forEach(async (student) => {
            //await this.delay(1000);
            //console.log(
            //  student.name + " - No se ha formado grupo (" + index + ")"
            //);
            await this.delay(3000);
            await messages.doc().set({
              email: student.email,
              message: `
                <p>Estimad${student.parentGender === "male" ? "o" : "a"} ${
                student.parentName.includes(",")
                  ? student.parentName.split(",")[1].trim()
                  : student.parentName
              }:</p>
                <p>Ha habido un error técnico en el envío de algunas comunicaciones de las actividades extraescolares asignadas a vuestros hijos. Os pedimos disculpas por las molestias que esto os haya podido causar. Creemos que el error ya está subsanado y en este correo la información ya debería aparecer corregida.</p>
                <p>Si notaseis nuevas incidencias, os rogamos que nos las comuniqueís a la mayor brevedad posible.</p>
                <p>Lamentamos comunicarle que el grupo con horario <b>${
                  group.schedule
                } ${
                group.name ? "(" + group.name + ")" : ""
              }</b> correspondiente a la actividad extraescolar <b>${
                this.activity.name
              }</b>, para el que <b>${
                student.name.includes(",")
                  ? student.name.split(",")[1].trim()
                  : student.name
              }</b> había realizado la inscripción, no se ha formado por falta de demanda.</p>
              <p>Póngase en contacto con nosotros en los próximos dos días a través del correo <a href="mailto:extraescolares@liceosorolla.es">extraescolares@liceosorolla.es</a> para buscar una actividad alternativa.</p>
                <br />
                <p>Un saludo. Agradecemos vuestra comprensión.</p>
              `,
            }).then(() => { console.log('Grupo no formado') });
            //await this.delay(1000);
            //console.log('mensaje enviado')
          });
        } else {
          for (let i = 0; i < group.students.length; i++) {
            let inOut = i < this.activity.max ? "dentro" : "fuera";
            if (inOut === "dentro") {
              await this.delay(3000);
              await messages.doc().set({
                email: group.students[i].email,
                message: `
                  <p>Estimad${
                    group.students[i].parentGender === "male" ? "o" : "a"
                  } ${
                  group.students[i].parentName.includes(",")
                    ? group.students[i].parentName.split(",")[1].trim()
                    : group.students[i].parentName
                }:</p>
                  <p>Ha habido un error técnico en el envío de algunas comunicaciones de las actividades extraescolares asignadas a vuestros hijos. Os pedimos disculpas por las molestias que esto os haya podido causar. Creemos que el error ya está subsanado y en este correo la información ya debería aparecer corregida.</p>
                  <p>Si notaseis nuevas incidencias, os rogamos que nos las comuniqueís a la mayor brevedad posible.</p>
                  <p><b>${
                    group.students[i].name.includes(",")
                      ? group.students[i].name.split(",")[1].trim()
                      : group.students[i].name
                  }</b> ha obtenido plaza en el grupo con horario <b>${
                  group.schedule
                } ${
                  group.name ? "(" + group.name + ")" : ""
                }</b> correspondiente a la actividad extraescolar <b>${
                  this.activity.name
                }</b>.</b>
                  <br />
                  <p>Un saludo. Agradecemos vuestra comprensión.</p>
                  `,
              }).then(() => { console.log('Confirmar plaza') });
            } else {
              await this.delay(3000);
              await messages.doc().set({
                email: group.students[i].email,
                message: `
                  <p>Estimad${
                    group.students[i].parentGender === "male" ? "o" : "a"
                  } ${
                  group.students[i].parentName.includes(",")
                    ? group.students[i].parentName.split(",")[1].trim()
                    : group.students[i].parentName
                }:</p>
                  <p>Ha habido un error técnico en el envío de algunas comunicaciones de las actividades extraescolares asignadas a vuestros hijos. Os pedimos disculpas por las molestias que esto os haya podido causar. Creemos que el error ya está subsanado y en este correo la información ya debería aparecer corregida.</p>
                  <p>Si notaseis nuevas incidencias, os rogamos que nos las comuniqueís a la mayor brevedad posible.</p>
                  <p>Lamentamos comunicarle que <b>${
                    group.students[i].name.includes(",")
                      ? group.students[i].name.split(",")[1].trim()
                      : group.students[i].name
                  }</b> no ha obtenido plaza en el grupo con horario <b>${
                  group.schedule
                } ${
                  group.name ? "(" + group.name + ")" : ""
                }</b> correspondiente a la actividad extraescolar <b>${
                  this.activity.name
                }</b> debido a la gran demanda. Todavía esta en la lista de espera, si hubiese alguna baja nos pondremos en contacto con usted.</p>
                  <br />
                  <p>Un saludo. Agradecemos vuestra comprensión.</p>
                `,
              }).then(() => { console.log('Denegar plaza') });
            }
            //await this.delay(1000);
            //console.log('mensaje enviado')
            //console.log(group.students[i].name + " - " + inOut);
          }
        }
      });*/
    },
    changeStudents(group, activityId) {
      activityId;
      for (let i = 0; i < group.students.length; i++) {
        group.students[i].index = i;
        activities.doc(activityId).update({
          [`groups.${group.id}.students.${group.students[i].id}.index`]: i,
        });
      }
    },
    /*async changeStudents2($event, activityId, groupId) {
      if ($event.moved) {
        console.log($event);
        await activities
          .doc(activityId)
          .get()
          .then(async (activityRef) => {
            Object.values(activityRef.data().groups[groupId].students).forEach(
              async (student) => {
                if (
                  $event.moved.oldIndex > student.index &&
                  $event.moved.newIndex <= student.index
                ) {
                  console.log("SUMANDO");
                  await activities.doc(activityId).update({
                    [`groups.${groupId}.students.${student.id}.index`]: fs.FieldValue.increment(
                      1
                    ),
                  });
                }
                if (
                  $event.moved.oldIndex < student.index &&
                  $event.moved.newIndex >= student.index
                ) {
                  console.log("RESTANDO");
                  await activities.doc(activityId).update({
                    [`groups.${groupId}.students.${student.id}.index`]: fs.FieldValue.increment(
                      -1
                    ),
                  });
                }
              }
            );
            console.log("ACTUALIZANDO");
            await activities.doc(activityId).update({
              [`groups.${groupId}.students.${$event.moved.element.id}.index`]: $event
                .moved.newIndex,
            });
          });
      }
    },*/
    showPriority(n) {
      switch (n) {
        case 1:
          return "mdi-numeric-1-circle";
        case 2:
          return "mdi-numeric-2-circle";
        case 3:
          return "mdi-numeric-3-circle";
        case 4:
          return "mdi-numeric-4-circle";
        case 5:
          return "mdi-numeric-5-circle";
        case 6:
          return "mdi-numeric-6-circle";
        case 7:
          return "mdi-numeric-7-circle";
        case 8:
          return "mdi-numeric-8-circle";
        case 9:
          return "mdi-numeric-9-circle";
      }
    },
    showPriorityColor(n) {
      switch (n) {
        case 1:
          return "teal lighten-4";
        case 2:
          return "teal lighten-3";
        case 3:
          return "teal darken-2";
        case 4:
          return "teal darken-1";
        case 5:
          return "teal";
        case 6:
          return "teal darken-1";
        case 7:
          return "teal darken-2";
        case 8:
          return "teal darken-3";
        case 9:
          return "teal darken-4";
      }
    },
    updatePriority(activity, group, student) {
      let newPriority = 0;
      if (student.priority === 9) {
        newPriority = 1;
      } else {
        newPriority = student.priority + 1;
      }
      activities
        .doc(activity.id)
        .update({
          [`groups.${group.id}.students.${student.id}.priority`]: newPriority,
        })
        .then(() => {
          let groupIndex = _.findIndex(this.activity.groups, { id: group.id });
          let studentIndex = _.findIndex(
            this.activity.groups[groupIndex].students,
            { id: student.id }
          );
          console.log(groupIndex, studentIndex);
          this.activity.groups[groupIndex].students[studentIndex].priority =
            newPriority;
        });
    },
    deleteGroup() {
      console.log("DELETE", this.groupToDelete);
      activities
        .doc(this.activity.id)
        .update({
          [`groups.${this.groupToDelete.id}`]: fs.FieldValue.delete(),
        })
        .then(() => {
          let index = _.findIndex(this.activity.groups, {
            id: this.groupToDelete.id,
          });
          this.activity.groups.splice(index, 1);
          this.groupToDelete = {};
          this.deleteGroupDialog = false;
        });
    },
    loadStudent($event) {
      console.log($event);
      this.student = $event;
      setTimeout(() => {
        this.$refs.student.getAvailables();
        this.$refs.students.selectStudent($event);
      }, 100);
      this.activity = {};
    },
    loadActivity($event) {
      console.log("LOAD");
      activities
        .doc($event.id)
        .get().then((activityRef) => {
          let activity = activityRef.data();
          let groups = [];
          Object.values(activity.groups).map((group) => {
            groups.push(group);
          });
          groups.forEach((group) => {
            let students = [];
            Object.values(group.students).map((student) => {
              students.push(student);
            });
            group.students = students.sort((a, b) => {
              return a.index - b.index;
            });
          });
          activity.groups = groups.sort((a, b) => {
            if (a.date < b.date) {
              return -1;
            } else {
              return 1;
            }
          });
          this.activity = activity;
        });
    },
    addNewGroup() {
      if (!this.newGroup.id) {
        let id = newId();
        activities
          .doc(this.activity.id)
          .update({
            ["groups." + id]: {
              id,
              ...this.newGroup,
              students: {},
              date: new Date(),
            },
          })
          .then(() => {
            this.activity.groups.push({
              id,
              ...this.newGroup,
              students: {},
              date: new Date(),
            });
            this.newGroupDialog = false;
            this.newGroup = {};
          });
      } else {
        activities
          .doc(this.activity.id)
          .update({
            [`groups.${this.newGroup.id}`]: this.newGroup,
          })
          .then(() => {
            let index = _.findIndex(this.activity.groups, {
              id: this.newGroup.id,
            });
            this.$set(this.activity.groups, index, this.newGroup);
            this.newGroup = {};
            this.newGroupDialog = false;
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.uploader-box {
  cursor: pointer;
  display: inline-block;
  position: relative;
  width: 78px;
  height: 70px;
  border: 3px grey dashed;
  border-radius: 10px;
  overflow: hidden;
  margin-right: 5px;
  .uploader-files {
    outline: none;
    position: absolute;
    top: 0px;
    left: 0px;
    width: 78px;
    height: 70px;
    opacity: 0;
  }
}
.thumbnail {
  width: 78px;
  height: 70px;
  display: inline-block;
  margin: 3px;
  position: relative;
  border-radius: 5px;
  .image {
    border-radius: 5px;
    overflow: hidden;
  }
  .remove-image {
    border: 1px solid white;
    background-color: black;
    color: white;
    position: absolute;
    top: -5px;
    right: -5px;
  }
}
.selected {
  border-bottom: 1px solid lightgrey;
}
</style>
